import { createFileRoute } from "@tanstack/react-router";
import heroAsset from "@/assets/appliance-removal-hero.webp.asset.json";
const heroImg = heroAsset.url;
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/appliance-removal")({
  head: () => ({
    meta: [
      { title: services["appliance-removal"].metaTitle },
      { name: "description", content: services["appliance-removal"].metaDescription },
      { property: "og:title", content: services["appliance-removal"].metaTitle },
      { property: "og:description", content: services["appliance-removal"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/appliance-removal" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/appliance-removal" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Appliance Removal', url: 'https://anchorsrq.com/appliance-removal' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "appliance-removal", name: 'Appliance Removal', serviceType: 'Appliance Removal', description: 'Safe disconnect and removal of refrigerators, washers, dryers, ranges, and water heaters across the Sarasota coast — a supporting service of Anchor Services with responsible recycling included.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["appliance-removal"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["appliance-removal"]} heroImg={heroImg} />,
});
